exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".congregation-form .field>label{-webkit-box-flex:0;-ms-flex:0 120px;flex:0 120px}.congregation-form .field>label:before{display:inline;content:\"Campus\"}", "", {"version":3,"sources":["/home/tim/blackpulp/docker-apps/plan-your-visit-user/resources/frontend/src/components/form-route/forms/CongregationForm.less"],"names":[],"mappings":"AAAA,gCAGM,mBAAA,iBAAA,YAAA,CAEA,uCACE,eACA,gBAAS,CAAA","file":"CongregationForm.less","sourcesContent":[".congregation-form {\n  .field {\n    >label {\n      flex: 0 120px;\n\n      &:before {\n        display: inline;\n        content: 'Campus';\n      }\n    }\n  }\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":true,"noIeCompat":true,"paths":["/home/tim/blackpulp/docker-apps/plan-your-visit-user/resources/frontend/node_modules","/home/tim/blackpulp/docker-apps/plan-your-visit-user/resources/frontend/assets"]}!./src/components/form-route/forms/CongregationForm.less
// module id = 278
// module chunks = 0